export function HomeLocationStoryDetails() {
  const STORY_PROMPTS = [
    'What led to this change in location?',
    'What were your first impressions?',
    'How did this move impact your life?',
    'What memories stand out from this place?',
    'How did the environment or community influence you?'
  ]

  return (
    <div className="space-y-12">
      {/* Story Section */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Your Story</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          {STORY_PROMPTS.map((prompt) => (
            <div key={prompt} className="mb-8 last:mb-0">
              <label className="block text-lg text-gray-700 font-medium mb-3">
                {prompt}
              </label>
              <textarea
                className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
                placeholder="Share your experiences..."
              />
            </div>
          ))}
        </div>
      </div>

      {/* Key People */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Key People</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          <div className="flex flex-wrap gap-4">
            {['Family Members', 'Neighbors', 'Real Estate Agent', 'Roommates', 'Property Manager'].map((person) => (
              <span key={person} className="px-6 py-3 text-lg rounded-full bg-gray-100 text-gray-700">
                {person}
              </span>
            ))}
            <button className="px-6 py-3 text-lg rounded-full bg-[#556B2F] text-white">
              Add Person
            </button>
          </div>
        </div>
      </div>

      {/* Media Upload */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Photos & Documents</h2>
        
        <div className="bg-white rounded-lg p-8 border border-gray-200">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="border-2 border-dashed border-[#556B2F] rounded-lg p-8 text-center min-w-[250px]">
              <span className="text-lg text-[#556B2F]">Upload Files</span>
            </div>
            <div className="space-y-4">
              <p className="text-lg text-gray-700">Suggested items:</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
                <p className="text-lg text-gray-600">• Property photos</p>
                <p className="text-lg text-gray-600">• Moving day pictures</p>
                <p className="text-lg text-gray-600">• Lease/Purchase documents</p>
                <p className="text-lg text-gray-600">• Before/After photos</p>
                <p className="text-lg text-gray-600">• Neighborhood views</p>
                <p className="text-lg text-gray-600">• Home improvements</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 